module.exports = __webpack_public_path__ + "img/learnEnglishMain-mobile.f7c63f18.png";